import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../../../../shared/components/Sifra';
import useHttp from '../../../../../../../hooks/use-http';
import MantineGrid from '../../../../../../UI/MantineGrid/ManiteGrig';
import { TabContext } from '../../../../../../../Context/TabContext';
import { urls } from './api/urls';
import { formatDateFromDB } from '../../../../../../../../utils/FormatDate';

const PONUGridProvider = ({ idMasine }) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { sendRequest, data, getData } = useHttp('');

  useEffect(() => {
    sendRequest({
      method: 'POST',
      url: urls.GET_PONUDE_ZA_MASINU,
      data: { id: idMasine },
    });
  }, []);

  const handleOpenDetail = (item) => {
    // console.log(item);
    const tab = {
      title: 'Detalji ponude',
      icon: 'fas fa-file',
      type: 10017,
      data: { pregledMasina: item },
    };
    addTab(tab);
  };
  const handleClickDok = async (item) => {
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: { idDok: item.idVeze },
    };
    addTab(tab);
  };
  const columns = [
    {
      field: 'ceoBrDok',
      headerName: t('offerId'),
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleOpenDetail(e.row.original)}
        />
      ),
      // size: 300,
    },
    {
      field: 'poDokumentu',
      headerName: t('requestId'),
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleClickDok(e.row.original)}
        />
      ),
      // size: 200,
    },
    {
      field: 'datum',
      headerName: t('date'),
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datum);
      },
      // size: 200,
    },
    {
      field: 'status',
      headerName: t('orderStatus'),
      // size: 200,
    },
    {
      field: 'ukupanIznos',
      headerName: t('amount'),
      size: 400,
    },
  ];

  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid columns={columns} data={data} />
    </div>
  );
};

export default PONUGridProvider;
